<template>
  <q-list>
    <q-item
      v-for="(item, index) in items"
      :item="item"
      :key="index"
      @click="selected(item)"
      clickable
    >
      <q-item-section>
        <div>
          {{ item.name }}
        </div>
        <div>
          <small class="text-uppercase text-primary">
            <account-type :value="item.type" />
          </small>
        </div>
      </q-item-section>
    </q-item>
  </q-list>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import AccountType from '@/iam/account/AccountType.vue';
import { Account } from '../types';

export default defineComponent({
  emits: ['selected'],
  components: { AccountType },
  props: {
    items: Array as () => Account[],
  },
  methods: {
    selected(item: Account|null): void {
      this.$emit('selected', item);
    },
  },
});
</script>
